import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import CircularLoader from "../../../../components/loaders/circularLoader";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import SingleSelect from "../../../../components/selections/singleSelect";
import CustomButton from "../../../../components/buttons/customButton";
import moment from "moment";

const COLORS = [
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    "linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%)",
    "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",
    "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
];

class TaskUpdation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leadStatusType: "",
            callStatusType: "",
            isFollowup: "",
            FollowUpDatetime: "",
            comments: "",
            errors: {},
            snackbar: { open: false, message: "", severity: "success" },
            getLeadHistory: [],
            status1: "idle",
            status2: "idle",
            callStatusTypes: [],
            leadStatusTypes: [],
            error: null,
        };
    }

    componentDidMount() {
        this.initializeData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.initializeData();
        }
    }

    initializeData = () => {
        const { rowData } = this.props;
        if (rowData?.wa_contact_id) {
            this.setState({
                leadStatusType: rowData?.lead_status_type_id ?? "-",
                callStatusType: rowData?.calling_status_id ?? "-"
            });
            this.fetchLeadHistory(rowData?.wa_contact_id);
        }
    };

    fetchLeadHistory = (waContactId) => {
        this.setState({ status1: "loading" });
        setTimeout(() => {
            this.setState({ status1: "succeeded", getLeadHistory: [] });
        }, 500);
    };

    handleSingleSelectChange = (name, selectedValue) => {
        this.setState((prev) => ({
            ...prev,
            [name]: selectedValue,
            errors: { ...prev.errors, [name]: "" },
        }));
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const { leadStatusType, callStatusType, FollowUpDatetime, comments } = this.state;
        const { rowData, handleClose } = this.props;

        const validations = [
            { valid: !!leadStatusType, message: "Status Type is required", field: "leadStatusType" },
            { valid: !!callStatusType, message: "Call Status is required", field: "callStatusType" },
        ];

        for (let rule of validations) {
            if (!rule.valid) {
                this.setState({
                    snackbar: { open: true, message: rule.message, severity: "error" },
                    errors: { ...this.state.errors, [rule.field]: rule.message },
                });
                return;
            }
        }

        try {
            this.setState({ status2: "loading" });

            const payload = {
                lead_status_type_id: leadStatusType,
                wa_contact_id: rowData?.wa_contact_id,
                calling_status_id: callStatusType,
                followup_time: FollowUpDatetime ? moment(FollowUpDatetime).unix().toString() : "",
                comments: comments,
            };

            setTimeout(() => {
                this.setState({
                    snackbar: { open: true, message: "Lead updated successfully", severity: "success" },
                    status2: "success",
                    leadStatusType: "",
                    callStatusType: "",
                    isFollowup: "",
                    FollowUpDatetime: "",
                    comments: "",
                    errors: {},
                });
                handleClose();
            }, 500);
        } catch {
            this.setState({
                snackbar: { open: true, message: "Server error. Please try again.", severity: "error" },
                status2: "error",
            });
        }
    };

    render() {
        const { leadStatusType, callStatusType, isFollowup, FollowUpDatetime, comments, errors, snackbar, getLeadHistory, status1, status2 } = this.state;
        const { rowData } = this.props;

        const updateFields = [
            { id: 1, name: "leadStatusType", value: leadStatusType, type: "select", label: "Lead Status", options: [{ value: 1, label: "New" }] },
            { id: 2, name: "callStatusType", value: callStatusType, type: "select", label: "Call Status", options: [{ value: 1, label: "Contacted" }] },
            { id: 3, name: "isFollowup", value: isFollowup, type: "select", label: "Is Followup", options: [{ value: 1, label: "Yes" }, { value: 2, label: "No" }] },
            ...(isFollowup === 1 ? [{ id: 4, name: "FollowUpDatetime", value: FollowUpDatetime, type: "date", label: "FollowUp Datetime" }] : []),
            { id: 5, name: "comments", value: comments, type: "textArea", label: "Enter Comments" }
        ];

        return (
            <Container fluid>
                <Row>
                    <Col xs={12} md={6} style={{ borderRight: "1px solid #e2e8f0", paddingRight: "16px" }}>
                        <h5 style={{ textAlign: "center", marginBottom: "16px" }}>Lead Update</h5>
                        <Form onSubmit={this.handleSubmit}>
                            {updateFields.map((field) => (
                                <Form.Group key={field.id} className="mb-3">
                                    {field.type === "select" && (
                                        <SingleSelect
                                            name={field.name}
                                            label={field.label}
                                            options={field.options}
                                            value={field.value}
                                            onChange={this.handleSingleSelectChange}
                                            error={!!errors[field.name]}
                                        />
                                    )}

                                    {field.type === "date" && (
                                        <Form.Control
                                            size="sm"
                                            type="datetime-local"
                                            label={field.label}
                                            value={field.value}
                                            onChange={(e) => this.setState({ [field.name]: e.target.value })}
                                        />
                                    )}

                                    {field.type === "textArea" && (
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            label={field.label}
                                            value={field.value}
                                            onChange={(e) => this.setState({ [field.name]: e.target.value })}
                                            placeholder={field.label}
                                        />
                                    )}
                                </Form.Group>
                            ))}

                            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                                <CustomButton
                                    status={status2}
                                    onClick={this.handleSubmit}
                                    label="Update"
                                    loadingLabel="Updating.."
                                />
                            </div>
                        </Form>
                    </Col>

                    <Col xs={12} md={6} style={{ paddingLeft: "16px" }}>
                        <h5 style={{ textAlign: "center", marginBottom: "16px" }}>Lead History</h5>

                        {status1 === "loading" && <CircularLoader color="success" />}

                        {status1 === "succeeded" && (
                            <div style={{ width: "100%", height: "400px", overflowY: "auto", marginTop: "8px" }}>
                                {getLeadHistory.length > 0 ? (
                                    getLeadHistory.map((item, index) => (
                                        <div key={index} style={{ marginBottom: "16px" }}>
                                            <p style={{ fontWeight: 600, fontSize: "12px", marginBottom: "8px", color: "#64748b" }}>
                                                {moment.unix(item.followup_time).format("DD MMM YYYY h:mm a")} followed by {item.employee_name}
                                            </p>
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    color: "white",
                                                    padding: "4px 8px",
                                                    borderRadius: "19px",
                                                    background: COLORS[index % COLORS.length],
                                                    marginBottom: "8px",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {item.calling_status}
                                            </div>
                                            <p style={{ fontSize: "12px", marginBottom: "8px" }}>
                                                {item.comments || "-"}
                                            </p>
                                            <hr style={{ margin: "8px 0" }} />
                                        </div>
                                    ))
                                ) : (
                                    <p style={{ display: "flex", justifyContent: "center" }}>No Data Found</p>
                                )}
                            </div>
                        )}
                    </Col>
                </Row>

                <SnackbarMessage
                    open={snackbar.open}
                    message={snackbar.message}
                    severity={snackbar.severity}
                    onClose={() => this.setState({ snackbar: { open: false, message: "", severity: "success" } })}
                />
            </Container>
        );
    }
}

export default TaskUpdation;
